import { useQuery } from "@tanstack/react-query";
import { PROFESSIONS_KEY } from "../constants";
import { httpClient } from "../../config";
import { API_PROFESSIONS } from "../../common/consts/apiUrls";

export interface ProfessionsResponse {
  message: string;
  data: {
    professions: Profession[];
  };
}

export interface Profession {
  id: number;
  profession: string;
  active: boolean;
}

const fetchProfessions = async (): Promise<ProfessionsResponse> => {
  return (await httpClient.get(API_PROFESSIONS)) as ProfessionsResponse;
};

export default function useProfessionsQuery(enabled = true) {
  return useQuery({
    queryKey: [PROFESSIONS_KEY],
    queryFn: fetchProfessions,
    enabled,
  });
}
